import type { IRemarkableInlineExtension } from '../types';

type ErrorToken = {
  type: string;
  content: string;
  level: number;
};

const name = 'error';

/**
 * Esta extensión permite mostrar un cuadro de advertencia usando la sintaxis:
 *
 * !!! Esto es una advertencia !!!
 */
export const errorExtension: IRemarkableInlineExtension = {
  name,
  parser: (state, silent) => {
    const start = state.pos;
    if (
      state.src.charCodeAt(start) !== 0x21 /* ! */ ||
      state.src.charCodeAt(start + 1) !== 0x21 /* ! */ ||
      state.src.charCodeAt(start + 2) !== 0x21 /* ! */
    ) {
      return false;
    }

    const match = state.src.slice(start).match(/^!!!(.+?)!!!/);

    if (!match || start + match[0].length > state.posMax) {
      return false;
    }

    if (!silent) {
      state.push({
        type: name,
        content: match[1],
        level: state.level,
      });
    }

    state.pos += match[0].length;
    return true;
  },

  replacer: (md) => (tokens, idx) => {
    const token = tokens[idx] as ErrorToken;
    return `<div class="${name}">${md.renderInline(token.content)}</div>`;
  },

  styles: () => `.${name} {
  padding: var(--space-5);
  background-color: var(--color-error-back);
  border-left: 3px solid var(--color-error-border);
  color: var(--color-error-text);
  margin: 10px 0;
  box-shadow: 0 2px 2px rgba(0,0,0,0.2);
}`,
};
